
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.502 9H11.507a1 1 0 00-1 .996v40.072a1 1 0 001 .995h35.995a1 1 0 001-.995V9.996a.994.994 0 00-1-.996zm-1 40.072H12.507v-38.08h33.995v38.08z"}}),_c('path',{attrs:{"d":"M18.146 23.615h22.727a1 1 0 001-.995v-6.7a1 1 0 00-1-.996H18.146a1 1 0 00-1 .995v6.7c0 .548.44.996 1 .996zm1-6.7h20.727v4.71H19.146v-4.71zM18.146 31.35h22.727a1 1 0 001-.995 1 1 0 00-1-.995H18.146a1 1 0 00-1 .995c0 .548.44.996 1 .996zM18.146 38.24h22.727a1 1 0 001-.995 1 1 0 00-1-.996H18.146a1 1 0 00-1 .996c0 .547.44.995 1 .995zM18.146 45.14h22.727a1 1 0 001-.996 1 1 0 00-1-.996H18.146a1 1 0 00-1 .996c0 .547.44.995 1 .995z"}})])
          )
        }
      }
    